/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iframe_Remote_No_Event_Group_Selected_MessageInputs */



/**
* | output |
* | --- |
* | "No event group is currently selected" |
*
* @param {Iframe_Remote_No_Event_Group_Selected_MessageInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iframe_remote_no_event_group_selected_message = /** @type {((inputs?: Iframe_Remote_No_Event_Group_Selected_MessageInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iframe_Remote_No_Event_Group_Selected_MessageInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun groupe d'evenements selectionne")
	if (locale === "de") return /** @type {LocalizedString} */ ("Es ist derzeit keine Ereignisgruppe ausgewählt.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun gruppo di eventi è attualmente selezionato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("В данный момент группа мероприятий не выбрана.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No hay ningún grupo de eventos seleccionado actualmente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("当前未选择任何事件组。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("現在イベントグループが選択されていません")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वर्तमान में कोई इवेंट समूह चयनित नहीं है")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nenhum grupo de eventos está selecionado no momento.")
	return /** @type {LocalizedString} */ ("No event group is currently selected")
});